import type { FC, ReactElement } from "react"

import { ETypographyColor, ETypographySize, ETypographyWeight, Typography } from "@/3514/components"
import { type IUseTranslation, useTranslation } from "@/hooks"
import type { TEmptyRenderCallback } from "@/shared/types/functions"

import { coachingChatComponentsGuards as guards } from "../guards"
import { coachingChatStyles as chatStyles } from "../styles"

const { withModeHeading: withGuard } = guards

const {
    conversation: { heading: classes }
} = chatStyles

type TProps = { renderBetaMark: TEmptyRenderCallback }

const Heading: FC<TProps> = ({ renderBetaMark }: TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <div className={classes.container()}>
            <Typography
                text={t("entities.coachingChat.chat.topLabel")}
                color={ETypographyColor.White}
                size={ETypographySize.Small}
                weight={ETypographyWeight.Bold}
            />

            {renderBetaMark()}
        </div>
    )
}

const GuardedHeading: FC = withGuard<TProps>(Heading)

GuardedHeading.displayName = "CoachingChatHeading"

export { GuardedHeading as CoachingChatHeading }
